/* ===========================================================================
   Grupo Marhel — theme.js
   Shared utilities, sticky header, mobile nav, quick view modal.
   Vanilla JS, no dependencies.
   =========================================================================== */
(function () {
  'use strict';

  /* ---------- Money formatting (mirrors Shopify) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(num, size) {
      var s = Math.abs(num).toFixed(size || 2);
      return s;
    }
    function withCommas(num, precision) {
      var parts = defaultTo(num / 100, precision).split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      var dec = parts[1] ? '.' + parts[1] : '';
      return intPart + dec;
    }
    function noDecimals(num) {
      var parts = String(Math.round(num / 100)).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }

    var match = fmt.match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = withCommas(cents, 2); break;
      case 'amount_no_decimals': value = noDecimals(cents); break;
      case 'amount_with_comma_separator': value = withCommas(cents, 2).replace(/,/g, '@').replace(/\./g, ',').replace(/@/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = noDecimals(cents).replace(/,/g, '@').replace(/\./g, ',').replace(/@/g, '.'); break;
      default: value = withCommas(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- Sub-brand accent (mirrors snippets/vendor-accent.liquid) ---------- */
  function vendorAccent(vendor) {
    var v = (vendor || '').toLowerCase().trim();
    if (v.indexOf('premium') > -1) return '#C99700';
    if (v.indexOf('powert') > -1) return '#1184B5';
    if (v.indexOf('lucky') > -1) return '#2E9B41';
    if (v.indexOf('sardina') > -1) return '#E0492C';
    if (v.indexOf('marhel') > -1) return '#0E7FA8';
    return '#005677';
  }

  function trapScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  window.Marhel = {
    formatMoney: formatMoney,
    vendorAccent: vendorAccent,
    trapScroll: trapScroll
  };

  /* ---------- Sticky header shadow ---------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var open = function () { nav.classList.add('is-open'); nav.setAttribute('aria-hidden', 'false'); trapScroll(true); };
    var close = function () { nav.classList.remove('is-open'); nav.setAttribute('aria-hidden', 'true'); trapScroll(false); };
    document.querySelectorAll('[data-mobile-nav-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-mobile-nav-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Quick view ---------- */
  function initQuickView() {
    var modal = document.querySelector('[data-quickview]');
    if (!modal) return;
    var media = modal.querySelector('[data-quickview-media]');
    var brandEl = modal.querySelector('[data-quickview-brand]');
    var titleEl = modal.querySelector('[data-quickview-title]');
    var priceEl = modal.querySelector('[data-quickview-price]');
    var formatEl = modal.querySelector('[data-quickview-format]');
    var descEl = modal.querySelector('[data-quickview-desc]');
    var variantInput = modal.querySelector('[data-quickview-variant]');
    var qtyInput = modal.querySelector('[data-quickview-qty]');
    var qtyField = modal.querySelector('[data-quickview-qty-field]');
    var form = modal.querySelector('[data-quickview-form]');
    var detailsLink = modal.querySelector('[data-quickview-details]');

    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); trapScroll(true); }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); trapScroll(false); }

    modal.querySelectorAll('[data-quickview-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function setQty(v) {
      var n = Math.max(1, parseInt(v, 10) || 1);
      qtyInput.value = n;
      if (qtyField) qtyField.value = n;
    }
    modal.querySelector('[data-quickview-qty-up]').addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
    modal.querySelector('[data-quickview-qty-down]').addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
    qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

    function load(handle) {
      fetch(window.Shopify && window.Shopify.routes ? '/products/' + handle + '.js' : '/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var available = p.available;
          var variant = null;
          for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { variant = p.variants[i]; break; } }
          if (!variant) variant = p.variants[0];

          media.innerHTML = '';
          var img = document.createElement('img');
          img.src = (p.featured_image || (p.images && p.images[0]) || '') + '';
          img.alt = p.title;
          media.appendChild(img);

          brandEl.textContent = p.vendor || '';
          brandEl.style.color = vendorAccent(p.vendor);
          titleEl.textContent = p.title;

          var priceHtml = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceHtml += '<s style="color:var(--slate-500);font-weight:500;font-size:.7em;margin-right:8px;">' + formatMoney(variant.compare_at_price) + '</s>';
          }
          priceHtml += formatMoney(variant.price);
          priceEl.innerHTML = priceHtml;

          formatEl.textContent = [p.type, (variant.title && variant.title !== 'Default Title') ? variant.title : ''].filter(Boolean).join(' · ');

          var tmp = document.createElement('div');
          tmp.innerHTML = p.description || '';
          descEl.textContent = (tmp.textContent || '').slice(0, 220);

          variantInput.value = variant.id;
          setQty(1);

          var addBtn = modal.querySelector('[data-quickview-add]');
          if (!available) { addBtn.setAttribute('disabled', ''); addBtn.textContent = (window.theme.strings.sold_out || 'Agotado'); }
          else { addBtn.removeAttribute('disabled'); addBtn.textContent = (window.theme.strings.add_to_cart || 'Agregar al Carrito'); }

          detailsLink.setAttribute('href', p.url);
          open();
        })
        .catch(function () { window.location.href = '/products/' + handle; });
    }

    /* Delegate quick-view triggers.
       The card's stretched .pcard__link overlays the whole card, so both
       listeners run in the CAPTURE phase to win before the link reacts. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      load(btn.getAttribute('data-quick-view'));
    }, true);

    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.stopPropagation();
    }, true);

    /* quick view add → use shared cart add */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (window.Cart && window.Cart.add) {
        window.Cart.add(variantInput.value, parseInt(qtyInput.value, 10) || 1, function () { close(); });
      } else {
        form.submit();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initMobileNav();
    initQuickView();
  });
})();

// === SCROLL ANIMATIONS ===
(function() {
  function initAnimations() {
    var body = document.body;
    if (!body) return;
    if (body.dataset.animations === 'false') return;

    // Fade-in observer
    if (body.dataset.animFadein === 'true') {
      var fadeEls = document.querySelectorAll('.anim-fade');
      var reveal = function (el) { el.classList.add('is-visible'); };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              reveal(e.target);
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

        fadeEls.forEach(function (el) { io.observe(el); });

        /* Fail-safe: .anim-fade starts at opacity 0, so anything the observer
           never reports on (background tab at load, zero-area target, layout
           shift) would stay invisible forever. Reveal whatever is in view once
           the page is fully loaded. */
        var sweep = function () {
          fadeEls.forEach(function (el) {
            if (el.classList.contains('is-visible')) return;
            var r = el.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) {
              reveal(el);
              io.unobserve(el);
            }
          });
        };
        window.addEventListener('load', function () { setTimeout(sweep, 200); });
      } else {
        fadeEls.forEach(reveal);
      }
    }

    // Parallax hero
    if (body.dataset.animParallax === 'true') {
      var parallaxEls = document.querySelectorAll('.hero__bg-parallax');
      if (parallaxEls.length) {
        window.addEventListener('scroll', function () {
          var scrollY = window.scrollY;
          parallaxEls.forEach(function (el) {
            el.style.transform = 'translateY(' + (scrollY * 0.25) + 'px)';
          });
        }, { passive: true });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAnimations);
  else initAnimations();
})();

// === MEGA MENU CHILD HOVER IMAGE SWAP ===
(function() {
  document.querySelectorAll('.nav__item--mega').forEach(function(item) {
    var links = item.querySelectorAll('.mega__link[data-img]');
    var mediaEl = item.querySelector('.mega__media');
    if (!mediaEl || !links.length) return;
    var originalHTML = mediaEl.innerHTML;
    links.forEach(function(link) {
      link.addEventListener('mouseenter', function() {
        var src = link.getAttribute('data-img');
        var label = link.getAttribute('data-label') || '';
        mediaEl.innerHTML = '<div class="mega__img-wrap"><img src="' + src + '" class="mega__img" alt="' + label + '" style="width:100%;height:100%;object-fit:cover;"><span class="mega__img-label">' + label + '</span></div>';
      });
      link.addEventListener('mouseleave', function() {
        mediaEl.innerHTML = originalHTML;
      });
    });
  });
})();
